"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const dbImageSchema = new mongoose_1.Schema({
    name: {
        type: String,
        enum: Object.values(enum_1.DatabaseEngine),
        required: true,
    },
    image_url: {
        type: String,
        required: true,
    },
    image: {
        type: String,
        required: true,
    },
    version: {
        type: String,
        required: true,
    },
    envs: {
        type: Array,
        required: true,
    },
    is_available: {
        type: Boolean,
        default: true,
    },
    is_default: {
        type: Boolean,
        default: false,
    },
    has_port: {
        type: Boolean,
        default: true,
    },
    port: {
        type: Number,
        required: true
    },
    volumePath: {
        type: String,
        required: true,
        default: "/data"
    },
    recommendations: {
        required: false,
        type: Array,
        default: []
    }
}, { timestamps: true });
exports.default = (0, mongoose_1.model)("DbImage", dbImageSchema);
